import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { SidenavService } from '../services/sidenav.service';

@Injectable({
    providedIn: 'root',
})
export class TokenGuard implements CanActivate {
    token!: string;

    constructor(
        private authService: AuthService,
        private router: Router,
        private storageService: StorageService,
        private sidenavService: SidenavService,
    ) { }

    async canActivate(): Promise<boolean> {
        try {
            const token = await this.storageService.getString(environment.config.tokenKey);

            if (this.authService.isTokenExpired(token) || !token) {
                this.router.navigate(['/pages/login']);
                return false;
            } else {
                // get the sidenavData if we have a valid token
                this.sidenavService.storeSidenavData();

                return true;
            }
        } catch (error) {
            this.router.navigate(['/pages/login']);
            return false;
        }
    }
}